import { RouteMetadata } from './types';

export const teamMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/team',
        section: 'team',
        view: 'list',
        descriptionTemplate: 'User is viewing the organization team members',
        capabilities: [
            'View active members and pending invitations',
            'Invite a person by email as viewer or editor',
            'Change a member role between viewer and editor',
            'Remove a member or cancel a pending invitation',
        ],
        hints: [
            'Membership lives in Voxity; changes apply to the Voxity console too',
            'Owners cannot be re-roled or removed',
            'People with a Voxity account are added immediately; others receive an invitation',
        ],
    },
];
